import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "./Context";

const PrivateRoute = ({ children, superAdminOnly = false }) => {
  const { user, loading } = useContext(UserContext);

  // ⏳ Wait until auth check completes
  if (loading) {
    return <div>Loading...</div>; // or spinner
  }



  // 🔒 Not logged in
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // 🚫 Super admin only
  if (superAdminOnly && user.role !== "superadmin") {
    return <Navigate to="/404" replace />;
  }

  return children;
};

export default PrivateRoute;
